/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, } from './Address';
/**
 * Check if a given object implements the LocationListEntry interface.
 */
export function instanceOfLocationListEntry(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function LocationListEntryFromJSON(json) {
    return LocationListEntryFromJSONTyped(json, false);
}
export function LocationListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': json['active'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'nielsenArea': !exists(json, 'nielsenArea') ? undefined : json['nielsenArea'],
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'provider': !exists(json, 'provider') ? undefined : json['provider']
    };
}
export function LocationListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'address': AddressToJSON(value.address),
        'nielsenArea': value.nielsenArea,
        'networkId': value.networkId,
        'referenceId': value.referenceId,
        'provider': value.provider
    };
}
